export default __webpack_public_path__ + "static/media/REKA_IKONA.3c5c8548.png";